import i18n from "../../i18n/i18n";
import stringHelper from "./stringHelper";
import constants from "../constants";

const axios = require('axios');

class StateHelper {


  isStateLoaded(imagesQueue, key) {
    for (let i = 0; i < imagesQueue.length; i++) {
      if (key === imagesQueue[i]) return false;
    }
    return true;
  }

  getHotspotLink(hotspotKey, array) {
    for (let i = 0; i < array.length; i++) {
      const hotspot = array[i];
      if (hotspot.key === hotspotKey && hotspot.isLink) return hotspot.linkTo;
    }
    return "";
  }

  /**
   * Loop thru all states and for each state creates key and all images for that state pushes in one array.
   * Returns Array of states keys and Array of array images for each state.
   * @param data Json data from UMBRACO.
   */
  initializeBuildingStates(data) {
    let tempLoadingQueue = [];
    let tempImagesQueue = [];
    for (let i = 0; i < data.rowsPerState.length; i++) {
      let rows = data.rowsPerState[i];
      for (let j = 0; j < rows; j++) {

        let key = stringHelper.makeStateKey("B", "High", i, j);
        let fakeQueue = [];

        for (let k = 0; k < data.states[i].rows[j].highResUrls.length; k++) {
          let fakeDictionary = [];
          let path = data.states[i].rows[j].highResUrls[k];
          fakeDictionary[0] = k;
          fakeDictionary[1] = path;
          fakeQueue.push(fakeDictionary);
        }

        tempLoadingQueue.push(fakeQueue);
        tempImagesQueue.push(key);
      }
    }

    return [tempLoadingQueue, tempImagesQueue];
  }

  /**
   * Loop thru all apartments  and for each apartment creates key and all images for that state pushes in one array.
   * Returns Array of apartments keys and Array of array images for each apartment.
   * @param states States Data.
   */
  initializeApartmentStates(states) {
    let tempLoadingQueue = [];
    let tempImagesQueue = [];

    for (let i = 0; i < states.length; i++) {
      let apartments = states[i].apartments;
      if (apartments.length > 0) {
        for (let j = 0; j < apartments.length; j++) {
          if (apartments[j].highResUrls.length > 0) {
            let apartmentStateKey = `A_High_${i}_${apartments[j].key}`;
            let fakeQueue = [];

            for (let k = 0; k < apartments[j].highResUrls.length; k++) {
              let fakeDictionary = [];
              let path = apartments[j].highResUrls[k];
              fakeDictionary[0] = k;
              fakeDictionary[1] = path;
              fakeQueue.push(fakeDictionary);
            }
            tempImagesQueue.push(apartmentStateKey);
            tempLoadingQueue.push(fakeQueue);
          }
        }
      }
    }

    return [tempLoadingQueue, tempImagesQueue];
  }

  /**
   * Creates loading queue with two separate arrays.
   * One for state keys, one for state image paths.
   */
  async initializeStartingQueue() {
    const currentUrl = new URL(window.location);
    const projectId = currentUrl.searchParams.get("projectId");

    const response = await axios.get(`${constants.production.API_URL}${projectId}`);
    
    let data = response.data;

    i18n.changeLanguage(data.language);

    let canvas = document.getElementById("root");
    let event = new CustomEvent("setJsonData", {
      detail: {
        jsonData: data,
      }
    });
    canvas.dispatchEvent(event);

    let tempLoadingQueue = [];
    let tempImagesQueue = [];

    let loadingQueues = this.initializeBuildingStates(data);

    tempLoadingQueue = loadingQueues[0];
    tempImagesQueue = loadingQueues[1];

    loadingQueues = this.initializeApartmentStates(data.states);

    tempLoadingQueue = tempLoadingQueue.concat(loadingQueues[0]);
    tempImagesQueue = tempImagesQueue.concat(loadingQueues[1]);


    // Push Default States to be loaded first!
    let defaultFloor = data.currentState;
    for (let i = 0; i < data.rowsPerState[defaultFloor]; i++) {
      let key = stringHelper.makeStateKey("B", "High", defaultFloor, i);

      // Push this key to the beginning
      let indexOf = tempImagesQueue.indexOf(key);
      let array = tempLoadingQueue[indexOf];

      tempImagesQueue.splice(indexOf, 1);
      tempLoadingQueue.splice(indexOf, 1);

      tempLoadingQueue.unshift(array);
      tempImagesQueue.unshift(key);
    }
    return [tempLoadingQueue, tempImagesQueue];
  }

}

export default new StateHelper();
